// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__psRvc","logo":"Footer_logo__eTDCr","footermenu":"Footer_footermenu__W2Ngo","footersection":"Footer_footersection__9yw25"};